import { BalanceFilterType } from 'src/latest/src/features/billing-admin/patient-details/PatientDetailsConstant';
import makeApiRequest from '../../api/makeApiCall';
import { Config } from '../../latest/src/constants/AppServerConfig';

const VERIFICATION_SERVICE = Config.verificationService;

export const getBillingHomepage = async (payload: any) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}billing-homepage`,
    'POST',
    payload,
  );
};

export const chargeBillingAmount = async (payload: any, clientId: string) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}billings/clients/${clientId}/_charge`,
    'POST',
    payload,
  );
};

export const chargeDirectoryBillingAmount = async (
  payload: any,
  providerId: string,
) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}billings/providers/${providerId}/_charge`,
    'POST',
    payload,
  );
};

export const refundBillingAmount = async (
  payload: any,
  transactionId: string,
) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}transactions/${transactionId}/reverse`,
    'POST',
    payload,
  );
};

export const getAllTransactions = async (payload: any) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}transactions/_search`,
    'POST',
    payload,
  );
};

export const getPaymentPlans = async (clientId: string, limit: number) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans?clientId=${clientId}&limit=${limit}`,
    'GET',
  );
};

export const pausePaymentPlan = async (paymentPlanId: string) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans/${paymentPlanId}/pause`,
    'POST',
  );
};

export const resumePaymentPlan = async (paymentPlanId: string) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans/${paymentPlanId}/resume`,
    'POST',
  );
};

export interface CreatePaymentPlanPayload {
  clientId: string;
  paymentAmount: number;
  frequency: 'WEEKLY' | 'BIWEEKLY' | 'MONTHLY';
  startDate: string;
  maxFailures: number;
  autoPauseOnFailure: boolean;
}

export const createPaymentPlan = async (payload: CreatePaymentPlanPayload) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans`,
    'POST',
    payload,
  );
};

export const deletePaymentPlan = async (
  paymentPlanId: string,
  reason: string,
) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans/${paymentPlanId}?reason=${reason}`,
    'DELETE',
  );
};

export const updatePaymentPlan = async (
  paymentPlanId: string,
  payload: any,
) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans/${paymentPlanId}`,
    'PUT',
    payload,
  );
};

export const getTransactionLedger = async (
  clientId: string,
  page: number,
  size: number,
  balanceFilter: BalanceFilterType,
) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}transaction-ledger/clients/${clientId}?page=${page}&size=${size}&balance_filter=${balanceFilter}`,
    'GET',
  );
};

export const getClientStripeScret = async () => {
  return await makeApiRequest(`${VERIFICATION_SERVICE}stripe-connect`, 'POST');
};

export const fetchBalance = async (ids: string) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}cron-job/_start_fetch_balance?ids=${ids}`,
    'GET',
  );
};

export const getPaymentPlansLatest = async (clientId: string) => {
  return await makeApiRequest(
    `${VERIFICATION_SERVICE}payment-plans/latest?clientId=${clientId}`,
    'GET',
  );
};

export const disputeCharge = async (
  transactionId: string,
  description: string,
) => {
  const payload = {
    reason: description,
  };

  return await makeApiRequest(
    `${VERIFICATION_SERVICE}transactions/${transactionId}/dispute`,
    'POST',
    payload,
  );
};
